<template>
  <nav class="w-full bg-white sticky top-0 z-[20] h-16 shadow-sm">
    <div class="flex justify-between mx-auto w-full max-w-full h-full">
      <div class=" flex justify-center py-2 px-3 text-text text-2xl h-full ml-2 min-w-[250px]">
        <RouterLink to="/">
          <img class="pt-2 pl-5 w-[170px]" src="@/assets/img/logo_oneclick1.svg">
        </RouterLink>
      </div>
      <div
          class="w-full h-20 lg:h-10 bg-white border-t border-gray-200 grid lg:grid-cols-2 grid-cols-1 items-center">
        <p class="font-medium text-lg text-dark2 flex h-full">

          <span v-if="route.name === 'home'" class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Companies</span>
          <span v-if="route.name === 'bussiness-lines-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Business Lines</span>
          <span v-if="route.name === 'branches-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Branches</span>
          <span v-if="route.name === 'client-permission-and-pages'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client Permissions and Pages</span>
          <span v-if="route.name === 'klg-permission-and-pages'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Klg Permissions and Pages</span>
          <span v-if="route.name === 'klg-permissions-import'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Klg Permissions Import</span>
          <span v-if="route.name === 'resources-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Json Resources</span>
          <span v-if="route.name === 'resources-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Json Resource Fields: {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'forms-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Forms</span>
          <span v-if="route.name === 'forms-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Form Fields: {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'option-categories-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Option Categories</span>
          <span v-if="route.name === 'option-category-values-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Option Values: {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'api-sources'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Sources</span>
          <span v-if="route.name === 'app-statuses'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">App Statuses</span>
          <span v-if="route.name === 'api-statuses'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Statuses</span>
          <span v-if="route.name === 'activity-statuses'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Activity Statuses</span>
          <span v-if="route.name === 'activity-types'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Activity Types</span>
          <span v-if="route.name === 'authorized-emails'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Authorized Emails</span>
          <span v-if="route.name === 'tooltip-categories'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Tooltip Categories</span>
          <span v-if="route.name === 'tooltip-values'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Tooltip Values: {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'departments'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Departments</span>
          <span v-if="route.name === 'notifications'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Notifications</span>
          <span v-if="route.name === 'alerts'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Alerts</span>
          <span v-if="route.name === 'currencies'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Currencies</span>
          <span v-if="route.name === 'sales-persons'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Sales Persons</span>
          <span v-if="route.name === 'payment-terms'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Payment Terms</span>
          <span v-if="route.name === 'invoice-lines'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Invoice Lines</span>
          <span v-if="route.name === 'klg-users-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">User Management</span>
          <span v-if="route.name === 'klg-manage-user'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Manage User</span>
          <span v-if="route.name === 'klg-roles-permissions'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">KLG Roles & Permissions</span>
          <span v-if="route.name === 'klg-roles-permissions-login-as'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Login as Roles & Permissions</span>
          <span v-if="route.name === 'clients-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Companies</span>
          <span v-if="route.name === 'company'" class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">{{
              navbarStore.pageTitle
            }} Overview</span>
          <span v-if="route.name === 'all-companies'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">All Companies Short Overview</span>
          <span v-if="route.name === 'create-prospect'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Add New Company</span>
          <span v-if="route.name === 'manage-prospect'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Edit Company</span>
          <span v-if="route.name === 'contacts'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Contacts</span>
          <span v-if="route.name === 'create-contact'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Add New Contact</span>
          <span v-if="route.name === 'edit-contact'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Edit Contact</span>
          <span v-if="route.name === 'client-roles-permissions'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Roles & Permissions</span>
          <span v-if="route.name === 'vendors'" class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Issued to KLG</span>
          <span v-if="route.name === 'vendor-invoice-details'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Invoice Details</span>
          <span v-if="route.name === 'customers'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Issued by KLG</span>
          <span v-if="route.name === 'customer-invoice-details'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Invoice Details</span>
          <span v-if="route.name === 'vbs-inbounds'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Warehousing Reception/Return</span>
          <span v-if="route.name === 'vbs-outbounds'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Warehousing Orders</span>
          <span v-if="route.name === 'inbounds'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Warehousing Simplify Reception/Return</span>
          <span v-if="route.name === 'outbounds'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Warehousing Simplify Orders</span>
          <span v-if="route.name === 'domestic-shipments'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Domestic Road</span>
          <span v-if="route.name === 'international-shipments'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">International Road</span>
          <span v-if="route.name === 'ocean'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Ocean </span>
          <span v-if="route.name === 'air'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Air </span>
          <span v-if="route.name === 'my-profile'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">My Profile </span>
          <span v-if="route.name === 'activity-log'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Activity Log</span>
          <span v-if="route.name === 'company-users'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Company Users</span>
          <span v-if="route.name === 'manage-client-user'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Manage Company User</span>
          <span v-if="route.name === 'chart-dashboard-editor'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">My Charts</span>
          <span v-if="route.name === 'legal-holidays'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Legal Holidays</span>
          <span v-if="route.name === 'general-settings'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">General Settings</span>
          <span v-if="route.name === 'emails'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Accepted Email Domains</span>
          <span v-if="route.name === 'company-emails'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Company Users Accepted Email Domains</span>
          <span v-if="route.name === 'incoterms'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Incoterms</span>
          <span v-if="route.name === 'packages'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Packages</span>
          <span v-if="route.name === 'features'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Features</span>
          <span v-if="route.name === 'shippers'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Shippers</span>
          <span v-if="route.name === 'webmail-domains'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Webmail Domains</span>
          <span v-if="route.name === 'maintenances'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Maintenances</span>
          <span v-if="route.name === 'site-notifications'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Site Notifications</span>
          <span v-if="route.name === 'releases'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Releases</span>
          <span v-if="route.name === 'api-resources-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Resources</span>
          <span v-if="route.name === 'api-resources-routes-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Routes</span>
          <span v-if="route.name === 'api-resources-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Resource Fields</span>
          <span v-if="route.name === 'api-route-groups'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Route Groups</span>
          <span v-if="route.name === 'api-releases'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">API Releases</span>
          <span v-if="route.name === 'application-api-route-groups'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Application API Route Groups</span>
          <span v-if="route.name === 'application-api-resources-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Application API Resources</span>
          <span v-if="route.name === 'application-api-resource-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Application API Resource Fields</span>
          <span v-if="route.name === 'application-api-route-fields'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Application API Routes</span>
          <span v-if="route.name === 'application-api-documentation'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Applications API Documentation</span>
          <span v-if="route.name === 'key-account-managers'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Key Account Managers</span>
          <span v-if="route.name === 'news'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Releases</span>
          <span v-if="route.name === 'client-news'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Customers Releases</span>
          <span v-if="route.name === 'admin-pages'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Admin Pages</span>
          <span v-if="route.name === 'admin-page-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Admin Page Fields : {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'client-pages'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client Pages</span>
          <span v-if="route.name === 'client-page-fields-listing'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client Page Fields : {{
              navbarStore.pageTitle
            }}</span>
          <span v-if="route.name === 'contract-managers'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Contract Managers</span>
          <span v-if="route.name === 'indoor-sales'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Indoor Sales</span>
          <span v-if="route.name === 'allowed-register-domains'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Allowed Register Domains</span>
          <span v-if="route.name === 'company-user-activity'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Company Users Activity</span>
          <span v-if="route.name === 'exchange-rates'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Exchange Rates</span>
          <span v-if="route.name === 'shipment-overview' || route.name === 'strongo-shipment-overview'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Shipment Overview</span>
          <span v-if="route.name === 'account-receivables'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Account Receivables</span>
          <span v-if="route.name === 'strongo-shipments'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Strongo</span>
          <span v-if="route.name === 'krakend-endpoints'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Krakend Endpoints</span>
          <span v-if="route.name === 'krakend-tokens'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Krakend Tokens</span>
          <span v-if="route.name === 'krakend-token-demands'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Krakend Token Demands</span>
          <span v-if="route.name === 'oneclick-tokens'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">OneClick Tokens</span>
          <span v-if="route.name === 'oneclick-token-demands'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">OneClick Token Demands</span>
          <span v-if="route.name === 'applications'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Registered Applications</span>
          <span v-if="route.name === 'application-demands'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Application Demands</span>
          <span v-if="route.name === 'user-activity'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Users Activity</span>
          <span v-if="route.name === 'ai-agents'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">AI Agents</span>
          <span v-if="route.name === 'ai-dashboard'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">AI Dashboard</span>
          <span v-if="route.name === 'cleo-documents'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Cleo Documents</span>
          <span v-if="route.name === 'cleo-history'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Cleo History</span>
          <span v-if="route.name === 'client-cleo-history'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client Cleo History</span>
          <span v-if="route.name === 'cleo-limits'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Cleo Limits</span>
          <span v-if="route.name === 'oneclick-documentation'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Documentation</span>
          <span v-if="route.name === 'admin-documentation'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Admin User Manual</span>
          <span v-if="route.name === 'client-documentation'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client User Manual</span>
          <span v-if="route.name === 'mcp-tokens'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">MCP Tokens</span>
          <span v-if="route.name === 'mcp-token-activities'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">MCP Activity Log</span>
          <span v-if="route.name === 'client-mcp-tokens'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client MCP Tokens</span>
          <span v-if="route.name === 'client-mcp-token-activities'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Client MCP Activity Log</span>
          <span v-if="route.name === 'cleo-insights'"
                class="min-w-[200px] inline-flex items-center text-md font-medium mt-4">Cleo Insights</span>

        </p>
      </div>

      <div class="hidden lg:flex justify-between">

        <div class="flex items-center space-x-10 mr-6  justify-end">
          <div>
            <template v-if="shouldShowLastUpdateFilter">
              <p class="text-text text-xs hidden lg:flex w-fit text-nowrap" v-if="getLastSynced(apiNameComputed)"> Last
                sync:
                {{ getLastSynced(apiNameComputed) }} minutes ago </p>
            </template>
            <template v-else-if="shouldShowCustomerLedgerEntriesLastUpdateFilter">
              <p class="text-text text-xs hidden lg:flex w-fit text-nowrap" v-if="getCustomerLedgerEntriesLastSynced">
                Last sync: {{ getCustomerLedgerEntriesLastSynced }} minutes ago </p>
            </template>
            <template v-else-if="shouldShowAccountReceivablesLastUpdateFilter">
              <p class="text-text text-xs hidden lg:flex w-fit text-nowrap" v-if="getAccountReceivablesLastSynced">
                Last sync: {{ getAccountReceivablesLastSynced }} minutes ago </p>
            </template>
            <template v-else-if="shouldShowVBSInboundsLastUpdateFilter">
              <p class="text-text text-xs hidden lg:flex w-fit text-nowrap" v-if="getVBSInboundLastSynced"> Last sync:
                {{ getVBSInboundLastSynced }} ago </p>
            </template>
            <template v-else-if="shouldShowVBSOutboundsLastUpdateFilter">
              <p class="text-text text-xs hidden lg:flex w-fit text-nowrap" v-if="getVBSOutboundLastSynced"> Last sync:
                {{ getVBSOutboundLastSynced }} ago </p>
            </template>
          </div>
          <NavbarNotifications></NavbarNotifications>
          <div class="items-center flex space-x-3">
            <p class="text-sm font-medium w-fit text-nowrap">{{ $t("nav.welcome_message") }}
              {{ authStore.user?.first_name }},</p>
            <div id="dropdown" @click="clickedmenu = !clickedmenu" class="flex space-x-3 relative cursor-pointer">
              <div v-if="authStore.user.image_data === null">
                <div class="rounded-full bg-primary w-8 h-8 flex items-center justify-center">
                  <span class="contents text-white text-center block text-sm font-semibold">
                    {{ authStore.user?.getInitials() }}
                  </span>
                </div>
              </div>
              <div v-else>
                <img class="max-w-8 max-h-8 rounded-full object-cover" :src="authStore.user.getProfilePicture()"
                     alt="Profile"/>
              </div>

              <img
                  :class="clickedmenu === true ? ' rotate-0 transition duration-150 ease-out' : 'rotate-180 transition duration-150 ease-out'"
                  src="@/assets/img/arrow.svg" class="" alt="arrow">
            </div>
            <OutsideClickContainer class="top-16 max-w-[250px] right-0"
                                   @outside-click="clickedmenu = false"
                                   v-if="clickedmenu">
              <Transition name="slide-fade">
                <div v-if="clickedmenu"
                     class=" bg-white z-10 relative shadow-lg py-4 px-6 rounded-md flex-col flex justify-start right-0 space-y-3">
                  <div class="flex space-x-3 items-center ">
                    <div v-if="authStore.user.image_data === null">
                      <div class="rounded-full bg-primary w-8 h-8 flex items-center justify-center pointer-events-none">
                        <span class="contents text-white text-center block text-sm font-semibold">
                          {{ authStore.user?.getInitials() }}
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <img class="w-11 h-11 rounded-full object-cover	"
                           :src="authStore.user?.getProfilePicture()" alt="Profile">
                    </div>
                    <p>{{ authStore.user?.first_name }} {{ authStore.user?.last_name }}</p>
                  </div>

                  <RouterLink :to="Tr.i18nRoute({ name: 'home' })">{{ $t("nav.home") }}</RouterLink>

                  <RouterLink
                      v-if="authStore.accountPermissions.allowedAny([
                                      'My Profile_enabled',
                                     ])"
                      :to="{name: 'my-profile' , params: { id: authStore.user?.id }}">

                    {{ $t("nav.my-profile") }}

                  </RouterLink>
                  <div class="border-t border-b-gray-300 pt-3">
                    <a class="cursor-pointer" @click="logout()">{{ $t("nav.logout") }}</a>
                  </div>
                </div>
              </Transition>
            </OutsideClickContainer>

          </div>
          <MainButton @click="openWidget()" type="primary-small">
            <div class="flex items-center space-x-1">
              <span>Help</span>
              <svg class="w-5 h-5 cursor-pointer inline-flex" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                   fill="currentColor">
                <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
          </MainButton>
        </div>
      </div>

    </div>
  </nav>
</template>

<script setup lang="ts">
import {onMounted, ref, computed, watch, onBeforeUnmount} from "vue";
import {useAuthStore} from "@/stores/auth";
import {useRouter} from "vue-router";
import {useRoute} from 'vue-router';
import {ApiImportResults} from "@/types/api-import-result";
import type {ApiImportResultsData} from "@/types/api-import-result";
import {useApiStore} from "@/stores/api";
import {useNavbarStore} from "@/stores/navbar";
import OutsideClickContainer from "@/components/OutsideClickContainer.vue";
import NavbarNotifications from "@/components/widgets/notifications/NavbarNotifications.vue";
import {useEmpathicWidgetStore, WidgetType} from "@/stores/empathicWidget.ts";

const clickedmenu = ref(false);
const authStore = useAuthStore();
const route = useRoute();
const api = useApiStore();
const navbarStore = useNavbarStore();
const empathicWidgetStore = useEmpathicWidgetStore();
const timeoutId = ref<number | null>(null)
const apiImportData = ref<ApiImportResults[]>([]);

const routeName = computed(() => {
  return route.name;
})

const loadLastSynced = () => {
  api.getItems<ApiImportResults, ApiImportResultsData>(
      'api-import-results',
      ApiImportResults,
      undefined,
      undefined,
      undefined,
  ).then((response) => {
    apiImportData.value = response
  })
      .finally(() => {
        if (loadLastSyncedData.value === true && timeoutId.value === null) {
          timeoutId.value = setTimeout(loadLastSynced, 60000);
        }
      })
}

onBeforeUnmount(() => {
  if (timeoutId.value !== null) {
    clearTimeout(timeoutId.value);
    timeoutId.value = null;
  }
});

const openWidget = (item: any) => {
  const name = authStore.user.getFullName();
  const email = authStore.user.email;

  const fields = {
    customer_name: {field: 'field_1755683901446', value: name},
    customer_email: {field: 'userEmail', value: email},
  };

  empathicWidgetStore.openWidget(WidgetType.HELP, fields);
};

const shouldShowLastUpdateFilter = computed(() => {
  return ["ocean", "air", "domestic-shipments", "international-shipments", "inbounds", "outbounds", "strongo-shipments"].includes(routeName.value);
})

const shouldShowCustomerLedgerEntriesLastUpdateFilter = computed(() => {
  return ["customers"].includes(routeName.value);
})

const shouldShowAccountReceivablesLastUpdateFilter = computed(() => {
  return ["account-receivables"].includes(routeName.value);
})

const shouldShowVBSInboundsLastUpdateFilter = computed(() => {
  return ["vbs-inbounds"].includes(routeName.value);
})
const shouldShowVBSOutboundsLastUpdateFilter = computed(() => {
  return ["vbs-outbounds"].includes(routeName.value);
})

const apiNameComputed = computed(() => {
  // console.log(route.name, 'route.name')
  switch (route.name) {
    case 'domestic-shipments':
      return 'ROAD';
    case 'international-shipments':
      return 'ROAD';
    case 'ocean':
      return 'SEA';
    case 'air':
      return 'SEA';
    case 'inbounds':
      return 'WMS';
    case 'outbounds':
      return 'WMS';
    case 'strongo-shipments':
      return 'STRONGO';
    default:
      return '';
  }
})

const getLastSynced = computed(() => (apiName: string) => {
  const lastApiImport = ref<ApiImportResults>();
  const importData = ref<ApiImportResults[]>([]);
  importData.value = apiImportData.value.filter(el => el.api_name === apiName);
  lastApiImport.value = importData.value.slice(-1)[0];
  const currentDate = new Date();
  if (lastApiImport.value?.start_time === null) {
    return;
  }
  const diff = lastApiImport.value?.start_time.getTime() - currentDate.getTime();
  const lastSynced = Math.floor(diff / (1000 * 60));
  return Math.abs(lastSynced);
})

const getCustomerLedgerEntriesLastSynced = computed(() => {
  const lastApiImport = ref<ApiImportResults>();
  const customerLedgerEntryImportData = ref<ApiImportResults[]>([]);
  customerLedgerEntryImportData.value = apiImportData.value.filter(el => el.api_name == 'Customer Ledger Entry');
  lastApiImport.value = customerLedgerEntryImportData.value.slice(-1)[0];
  const currentDate = new Date();
  if (lastApiImport.value?.start_time === null) {
    return;
  }
  const diff = lastApiImport.value?.start_time.getTime() - currentDate.getTime();
  const lastSynced = Math.floor(diff / (1000 * 60));
  return Math.abs(lastSynced);
})

const getAccountReceivablesLastSynced = computed(() => {
  const accountReceivableImportData = apiImportData.value.filter(el => el.api_name == 'Account Receivable');
  const lastApiImport = accountReceivableImportData.slice(-1)[0];

  if (!lastApiImport || !lastApiImport.start_time) {
    return undefined;
  }

  const currentDate = new Date();
  const diff = currentDate.getTime() - lastApiImport.start_time.getTime();
  const lastSynced = Math.floor(diff / (1000 * 60));
  return Math.abs(lastSynced);
})

const getVBSInboundLastSynced = computed(() => {
  const lastVBSInboundApiImport = ref<ApiImportResults>();
  const vbsInboundImportData = ref<ApiImportResults[]>([]);
  // vbsInboundImportData.value = apiImportData.value.filter(el => el.api_name == 'Ftp VBS' && el.result_status == 'finished');
  vbsInboundImportData.value = apiImportData.value.filter(el => el.api_name == 'Ftp VBS Inbound');
  lastVBSInboundApiImport.value = vbsInboundImportData.value.slice(-1)[0];
  let importedInbounds = 0;
  let i = -2;

  while (lastVBSInboundApiImport.value?.result_output) {
    const output = lastVBSInboundApiImport.value?.result_output.split(";");
    const importedOutboundsValue = output[0].split(":");
    importedInbounds = parseInt(importedOutboundsValue[1]);

    if (importedInbounds !== 0) {
      break;
    }
    lastVBSInboundApiImport.value = vbsInboundImportData.value.slice(i, i + 1)[0];
    i = i - 1;
  }

  const currentDate = new Date();
  if (!lastVBSInboundApiImport.value?.start_time) {
    return;
  }
  const diff = currentDate.getTime() - lastVBSInboundApiImport.value?.start_time.getTime();
  const lastVBSInboundSynced = ref('');
  const lastSyncedMinutes = Math.floor(diff / (1000 * 60));
  if (lastSyncedMinutes > 59) {
    const lastSyncedHours = Math.floor(diff / (1000 * 60 * 60));
    lastVBSInboundSynced.value = lastSyncedHours.toString() + ' hours';
  } else {
    lastVBSInboundSynced.value = lastSyncedMinutes.toString() + ' minutes';
  }
  return lastVBSInboundSynced.value;
})

const getVBSOutboundLastSynced = computed(() => {
  const lastVBSOutboundApiImport = ref<ApiImportResults>();
  lastVBSOutboundApiImport.value = apiImportData.value.find(el => el.api_name == 'Ftp VBS Outbound');

  const currentDate = new Date();
  if (!lastVBSOutboundApiImport.value?.start_time) {
    return;
  }
  const diff = currentDate.getTime() - lastVBSOutboundApiImport.value?.start_time.getTime();
  const lastVBSSynced = ref('');
  const lastSyncedMinutes = Math.floor(diff / (1000 * 60));
  if (lastSyncedMinutes > 59) {
    const lastSyncedHours = Math.floor(diff / (1000 * 60 * 60));
    lastVBSSynced.value = lastSyncedHours.toString() + ' hours';
  } else {
    lastVBSSynced.value = lastSyncedMinutes.toString() + ' minutes';
  }
  return lastVBSSynced.value;
})

const loadLastSyncedData = computed(() => {
  return shouldShowLastUpdateFilter.value ||
      shouldShowVBSInboundsLastUpdateFilter.value ||
      shouldShowVBSOutboundsLastUpdateFilter.value ||
      shouldShowAccountReceivablesLastUpdateFilter.value ||
      shouldShowCustomerLedgerEntriesLastUpdateFilter.value;
})

watch(loadLastSyncedData, (new_value) => {
  if (new_value === true) {
    loadLastSynced();

  }
})

onMounted(() => {
  /*window.addEventListener('click', function (e) {
    if (clickedmenu.value === true && (e.target.id != "dropdown")) {
      clickedmenu.value = false;
    }
  })*/

  if (loadLastSyncedData.value === true) {
    loadLastSynced();
  }
})

const logout = () => {
  authStore.logoutUser();
}

</script>

<script lang="ts">

import LanguageSwitcher from "@/components/LanguageSwitcher.vue"
import Tr from "../../i18n/translation"

export default {
  components: {LanguageSwitcher},
  setup() {
    return {Tr}
  }
}

</script>
